"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import { HeroSection } from "@/widgets/landing/ui/hero-section";
import { LandingFooter } from "@/widgets/landing/ui/landing-footer";
import { LandingHeader } from "@/widgets/landing/ui/landing-header";
import { LazySection } from "@/widgets/landing/ui/lazy-section";
import { ProblemSection } from "@/widgets/landing/ui/problem-section";
const ShowcaseSection = dynamic(() => import("@/widgets/landing/ui/showcase-section").then(m => m.ShowcaseSection), {
  ssr: false
});
const HowItWorksSection = dynamic(() => import("@/widgets/landing/ui/how-it-works-section").then(m => m.HowItWorksSection), {
  ssr: false
});
const FeaturesSection = dynamic(() => import("@/widgets/landing/ui/features-section").then(m => m.FeaturesSection), {
  ssr: false
});
const DataSections = dynamic(() => import("@/widgets/landing/ui/data-sections").then(m => m.DataSections), {
  ssr: false
});
const CtaSection = dynamic(() => import("@/widgets/landing/ui/cta-section").then(m => m.CtaSection), {
  ssr: false
});
export function LandingPageClient() {
  const $ = _c(8);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LandingHeader />;
    t1 = <HeroSection />;
    t2 = <ProblemSection />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LazySection minHeight="600px"><ShowcaseSection /></LazySection>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <LazySection minHeight="500px"><HowItWorksSection /></LazySection>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <LazySection minHeight="500px"><FeaturesSection /></LazySection>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <LazySection minHeight="400px"><DataSections /></LazySection>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="relative min-h-screen scroll-smooth bg-white text-slate-900 antialiased">{t0}<main>{t1}{t2}{t3}{t4}{t5}{t6}<LazySection minHeight="300px"><CtaSection /></LazySection></main><LandingFooter /></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}